"use client";

import * as React from "react";

export interface PageBodyProps {
  children: React.ReactNode;
}

export function PageBody({ children }: PageBodyProps) {
  return <main className="space-y-6">{children}</main>;
}
